export const trackingDetails = () => {
  // const params = new URLSearchParams(window.location.search);
  let params = {}
  try {
    params = JSON.parse(sessionStorage.getItem("utm_params")) || {};
  } catch (e) {
    params = {};
  }

  // Extract gclid from the URL
  const urlParams = new URLSearchParams(window.location.search);
  const gclid = urlParams.get('gclid') || ""; // Get gclid from URL
  const ScCid = urlParams.get('ScCid') || ""; // Get ScCid from URL
  const msclkid = urlParams.get('msclkid') || ""; // Get msclkid from URL
  // Localhost is stripped so Salesforce is not polluted by local submits.
  // Homepage (`/`) must still send the public URL (e.g. https://amityonline.com/).
  const pageUrl =
    window.location.hostname === "localhost"
      ? ""
      : window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;


  return {
    pageUrl: pageUrl,
    pageName: window.document.title,
    Custom21: gclid, // Use the extracted gclid
    Snapchat: ScCid, // Use the extracted ScCid
    Bing_Click_Id: msclkid, // Use the extracted ScCid
    AMSID: sessionStorage.getItem("AMSID") || "",
    utm_campaign_2: sessionStorage.getItem("utm_campaign_2"),
    utm_medium: params['utm_medium'],
    utm_media: params['utm_media'],
    utm_source: params['utm_source'] || "",
    utm_campaign: params['utm_campaign'] || "",
    utm_adid:  params['utm_adid'] || urlParams.get("utm_adid") || "",
    utm_adgroupid:  params['utm_adgroupid'] || urlParams.get("utm_adgroupid") || "",
    utm_adname: params['utm_adname'] || urlParams.get("utm_adname") || "", 
    utm_adset: params['utm_adset'] || urlParams.get("utm_adset") || "",
    utm_placement: params['utm_placement'] || urlParams.get("utm_placement") || "",
    utm_adsetid: params['utm_adgroupid'] || urlParams.get("utm_adgroupid") || "",
    utm_campaignid: params['utm_campaignid'] || urlParams.get("utm_campaignid") || "",   
    utm_campaigntype: params['utm_campaigntype'] || urlParams.get("utm_campaigntype") || "", 
    utm_content: params['utm_content'] || urlParams.get("utm_content") || "",
    utm_device: params['utm_device'] || urlParams.get("utm_device") || "",
    ...params,
  };
};
